import {
  getTranslatedText,
  getSourceIcon,
  ALL_MODULES,
  DEFAULT_FIELDS_BY_COLUMN_NAME
} from '@nile/components';
import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'react-clone-tippy';
import { useIntl } from 'react-intl';
import { useQuery } from '@apollo/client';
import { SVGIcon } from '@superops/super-icons';
import { AccountClient, GET_FIELD } from '@nile/graphql';
import { TextStyle, DisplayText } from '@superops/ui-design-system';

const StyledTag = styled.div`
  color: ${(props) => props.color || '#ffffff'};
  background: ${(props) => props.background};
`;

const TicketDisplayIdContainer = (props) => {
  const { ticket } = props;
  const { priority, source, ticketType, displayId } = ticket;
  const intl = useIntl();
  const sourceIcon = getSourceIcon(source) || 'InlineError';

  const { loading, data: priorityValues, error } = useQuery(GET_FIELD, {
    client: AccountClient,
    variables: {
      input: {
        module: ALL_MODULES.ticket,
        columnName: DEFAULT_FIELDS_BY_COLUMN_NAME.PRIORITY
      }
    }
  });

  if (loading) return <div>loading...</div>;
  if (error) return <div>An error occurred...</div>;

  const colors = {};
  const fldOptions =
    priorityValues?.getField?.options || priorityValues?.getField?.fieldOptions;
  fldOptions?.forEach((el) => {
    colors[el.value] = el.details?.colorCode;
  });

  const priorityTooltip = getTranslatedText(
    intl,
    'ticket.list.priority.tooltip'
  );
  const type = getTranslatedText(intl, 'common.type');
  const sourceToolTip = getTranslatedText(intl, 'ticket.list.source.tooltip');

  return (
    <Tooltip
      title="priority"
      html={
        <div className="p5">
          <DisplayText size="medium">
            <div className="type">
              <TextStyle>
                {`${type}: ${ticketType ||
                  getTranslatedText(intl, 'app.noData.message')}`}
              </TextStyle>
            </div>
            <div className="priority">
              <TextStyle>{`${priorityTooltip} ${priority ||
                getTranslatedText(intl, 'app.noData.message')}`}</TextStyle>
            </div>
            <div className="source">
              <TextStyle>{`${sourceToolTip} ${source ||
                getTranslatedText(intl, 'app.noData.message')}`}</TextStyle>
            </div>
          </DisplayText>
        </div>
      }
      delay={400}
      duration={250}
      position="bottom"
      inertia
      trigger="mouseenter"
      animation="shift"
      animateFill={false}
    >
      <div className="flex center min-width-130">
        <DisplayText size="medium" weight="Medium">
          <StyledTag
            className="priority-cell flex actr jctr rounded-4px p-2-8 g5"
            color="#424242"
            background={colors[priority] || '#9797974D'}
          >
            <SVGIcon name={sourceIcon} size="sm" color="#424242" />
            <span className="ml-5">
              {displayId ? (
                <TextStyle>#{displayId}</TextStyle>
              ) : (
                <TextStyle variation="subdued">NA</TextStyle>
              )}
            </span>
          </StyledTag>
        </DisplayText>
      </div>
    </Tooltip>
  );
};

export default TicketDisplayIdContainer;
